<script>
	import { useLocation } from "svelte-navigator";
    import { pageList, currentPage } from '../stores/pageStore';
    import model from "../stores/modelStore";

    import PageTrackerActive from './PageTrackerActive.svelte';
    import PageTrackerVisited from './PageTrackerVisited.svelte';
    import PageTrackerNotVisited from './PageTrackerNotVisited.svelte';

    let pageNumber;
	const location = useLocation();

    const getNodeComponent = function (pageIndex, nodeIndex) {
        if (pageIndex == nodeIndex) {
            return PageTrackerActive;
        } else if (pageIndex > nodeIndex) {
            return PageTrackerVisited;
        } else {
            return PageTrackerNotVisited;
        }
    }
    
    $: trackerPages = $pageList.filter(page => (typeof page.showInTracker == "function" ? page.showInTracker($model) : page.showInTracker));
    
    $: {
        $currentPage = $pageList.find(p => p.routeId == $location.pathname);
        if ($currentPage) {
            pageNumber = $currentPage ? $currentPage.pageIndex : 0;
        } else {
            $currentPage = $pageList[0];
            pageNumber = 0;
        }
        $model.PageNumber = pageNumber;
    }

</script>

<svelte:head>
	<title>{$currentPage ? $currentPage.pageTitle : "Super & Dis"}</title>
</svelte:head>

{#if ($pageList.length > 0 && typeof $pageList[pageNumber].showInTracker == "function" ? $pageList[pageNumber].showInTracker($model) : $pageList[pageNumber].showInTracker)}

<nav class="tracker-root">
    {#each trackerPages as page, i (page)}
        <div class="tracker-node" title="{page.title}">
            <svelte:component this={getNodeComponent(pageNumber, page.pageIndex)} routeId={page.routeId} title={page.title} />
        </div>
    {/each}
</nav>

{/if}


<style>

    .tracker-root {
        display: flex;
        padding-top: 16px;
        padding-bottom: 40px;
        justify-content: center;
    }

    @media (max-width: 1250px) {
        .tracker-root .node-icon-connector {
            left: calc(100% + 11px);
            width: calc(90px - 100%);
        }
    }

    @media (max-width: 992px) {
        :global(.tracker-root .node-icon-connector) {
            left: calc(100% + 12px);
            width: calc(70px - 100%);
        }
    }

    @media (max-width: 840px) {
        :global(.tracker-root .node-icon-connector) {
            display: none;
        }
    }

    :global(.node-icon) {
        color: #fff;
        width: 40px;
        border: 4px solid transparent;
        height: 40px;
        display: flex;
        position: relative;
        align-items: center;
        border-radius: 15px;
        margin-bottom: 16px;
        justify-content: center;
        background-color: #fafafa;
    }

    @media (max-width: 840px) {
        :global(.node-icon) {
            width: 100%;
            height: 100%;
        }
    }

    :global(.node-icon.visiting) {
        position: relative;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
        background-color: #fff;
    }

    :global(.node-icon.visiting:after) {
        top: 50%;
        left: 50%;
        width: 35%;
        height: 35%;
        content: "";
        position: absolute;
        transform: translate(-50%, -50%);
        border-radius: 4px;
        background-color: #E6692D;
    }

    @media (max-width: 840px) {
        :global(.node-icon.visiting:after) {
            display: none;
        }
    }

    :global(.node-icon.not-visited) {
        border: 4px solid #dadada;
    }

    :global(.node-icon.visited) {
        background-color: #E6692D;
        cursor: pointer;
    }

    :global(.node-icon-connector) {
        top: 50%;
        left: 42px;
        width: 60px;
        height: 4px;
        position: absolute;
        transform: translate(0, -50%);
        border-radius: 2px;
        background-color: #ffa14a;
        background-color: #dadada;
    }

    :global(.node-icon-connector.active) {
        background-color: #ffa14a;
    }

    :global(.tracker-node) {
        width: 100px;
        margin: 0 6px;
        display: flex;
        text-align: center;
        align-items: center;
        flex-direction: column;
    }

    :global(.tracker-node:last-child) {
        margin-right: 0;
    }

    :global(.tracker-node p) {
        width: 100%;
        word-wrap: break-word;
    }

    @media (max-width: 840px) {
        :global(.tracker-node) {
            width: 100%;
        }

        :global(.tracker-node p, .tracker-node a, .tracker-node svg) {
            display: none;
        }
    }

    :global(.tracker-node:last-child .node-icon .node-icon-connector) {
        display: none;
    }


    :global(.svg-tick-icon) {
        fill: currentColor;
        width: 1em;
        height: 1em;
        display: inline-block;
        font-size: 1.2857142857142856rem;
        transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        flex-shrink: 0;
        user-select: none;
    }

</style>